import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IRejectMeetingRequestByTokenPayload } from '@app-store/slices/meetingRequests/rejectByToken'

interface TaskAction extends Action {
    payload: IRejectMeetingRequestByTokenPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.rejectByToken

function* rejectMeetingRequestByTokenSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/meeting/meeting-requests/reject`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError()
    }
}

function* rejectMeetingRequestByTokenSaga(): any {
    yield takeLatest<TaskAction>(onRequest, rejectMeetingRequestByTokenSagaTask)
}

export default rejectMeetingRequestByTokenSaga
